/* eslint-disable react/prop-types */

import React, { useState } from 'react';
import { Form, Col } from 'react-bootstrap';
import { FormLabel } from './FormLabel';

const Dob = ({
  metadata,
  field,
  setValue,
  register,
  errors,
  ErrorFeedback
}) => {
  const [selectedDate, setSelectedDate] = useState(
    metadata.type === 'dob' && metadata.defaultValue
      ? new Date(metadata.defaultValue)
      : null
  );

  // Function to calculate date with offset
  const calculateDateWithOffset = (days, isSubtract = false) => {
    const date = new Date();
    const offsetMilliseconds = days * 24 * 60 * 60 * 1000;

    if (isSubtract) {
      date.setTime(date.getTime() - offsetMilliseconds);
    } else {
      date.setTime(date.getTime() + offsetMilliseconds);
    }

    return date.toISOString().split('T')[0];
  };

  // Calculate min and max dates based on validation
  const calculateDateRange = () => {
    const today = new Date().toISOString().split('T')[0];
    let minDate = null;
    let maxDate = null;

    if (metadata?.validation) {
      // Handle past days restriction
      if (
        metadata.validation.noOfPastDays ||
        metadata.validation.noOfPastDays === 0
      ) {
        minDate = calculateDateWithOffset(
          metadata.validation.noOfPastDays,
          true
        );
      }

      // Handle future days restriction
      if (
        metadata.validation.noOfFutureDays ||
        metadata.validation.noOfFutureDays === 0
      ) {
        maxDate = calculateDateWithOffset(metadata.validation.noOfFutureDays);
      }

      // Special handling for DOB type
      if (metadata.type === 'dob') {
        const eighteenYearsAgo = new Date();
        eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
        maxDate = eighteenYearsAgo.toISOString().split('T')[0];
      }

      // Handle noFutureDate validation
      if (metadata.validation.noFutureDate) {
        maxDate = today;
      }
    }

    return { minDate, maxDate };
  };

  const { minDate, maxDate } = calculateDateRange();

  // Handle date change
  const handleDateChange = e => {
    const newDate = e.target.value;
    setSelectedDate(newDate ? new Date(newDate) : null);
    if (setValue) {
      setValue(metadata.id, newDate);
    }
  };

  // Format default value to YYYY-MM-DD
  const formatDefaultValue = value => {
    if (!value) return '';
    // If it's a date string with time, extract just the date
    if (value.includes('T')) {
      return value.split('T')[0];
    }
    return value;
  };

  return (
    <Col>
      <Form.Group as={Col} sm={12} md={12} className="mb-3">
        <FormLabel
          label={metadata.label}
          required={metadata?.validation?.required}
        />
        <div className="mb-3">
          <Form.Control
            {...field}
            {...register(metadata.id, {
              setValueAs: value => {
                if (!value) return value;
                // Always return just the date part
                return value.includes('T') ? value.split('T')[0] : value;
              }
            })}
            type="date"
            placeholder={metadata.placeholder}
            min={minDate}
            max={maxDate}
            isInvalid={!!errors[metadata.id]}
            disabled={!metadata.isEditable}
            onChange={handleDateChange}
            defaultValue={formatDefaultValue(metadata.defaultValue)}
          />
          <ErrorFeedback error={errors[metadata.id]} />
        </div>
      </Form.Group>
    </Col>
  );
};

export default Dob;
